module.exports = __webpack_public_path__ + "static/cai_services_dataintegration_grower-d02654ba2ae16f435a5da31674b66d04.png";